export var WishlistEvents;
(function (WishlistEvents) {
    WishlistEvents["CHANGE"] = "wishlist:change";
})(WishlistEvents || (WishlistEvents = {}));
//# sourceMappingURL=wishlistEvents.js.map